<!--
 * @title: 页面名称
 * @Description: 
 * @Version: 2.0
 * @Autor: 研发三部
 * @Date: 2020-12-03 09:37:11
 * @LastEditors: jinzb
 * @LastEditTime: 2020-12-28 16:01:28
-->
<template>
    <div style="height: 100%;" class="ecolodical">
        <div class="content1">
            <div class="block">


                <div class="resource-title"> <i class="el-icon-minus title_icon"></i>草原退化情况</div>
                <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: 90%;">
                    <div style="margin: 0 5%; height: 100%;">

                        <div style="height: 100%;">
                            <div style="height: 90%;">
                                <rightTop></rightTop>
                            </div>
                        </div>

                    </div>

                </dv-border-box-1>
            </div>
            <div class="block">
                <div class="image_title">
                    草地类分布图
                </div>
                <div style=" height: 90%;width: 100%;border-radius: 10px;">
                    <el-carousel :interval="5000" arrow="always" style="height: 100%;">
                        <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                            <el-image :src="require('@/assets/large-screen-img/gl1.png')" fit="fit"
                                style="width: 100%;height: 100%;"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="block">
                <div class="resource-title"> <i class="el-icon-minus title_icon"></i>草原盖度</div>
                <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: 90%;">
                    <div style="margin: 0 5%;height: 100%;">
                        <div style="height: 100%;">
                            <div class="zhzb_title">
                                <div>
                                    综合植被盖度<span>&nbsp;&nbsp;&nbsp;&nbsp; 64.25%</span>
                                </div>
                            </div>
                            <div style="height: 80%;">
                                <div style="width: 100%;height: 100%;">
                                    <dv-scroll-board :config="config" style="width:100%;height:90%" />
                                </div>
                            </div>
                            
                        </div>
                    </div>




                </dv-border-box-1>
            </div>
        </div>
        <div class="content2">
            <div class="resource-title"> <i class="el-icon-minus title_icon"></i>退化治理情况</div>
            <dv-border-box-1 backgroundColor="rgba(14, 45, 40,0.5)" style="height: 100%">
                <div style="width:100%;height: 90%;display: flex;
    justify-content: space-around; ">
                    <div style="margin-left: 2%;width: 28%;height:100%;text-align: center;">
                        <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                            <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                    style="width: 100%;height: 100%;margin-top: 5%;"></el-image>
                            </el-carousel-item>
                        </el-carousel>
                        <div class="title_block">
                            <div class="pest_image_title">退化照片</div>
                        </div>

                    </div>
                    <div style="width: 28%;height:100%;text-align: center;">
                        <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                            <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                    style="width: 100%;height: 100%;margin-top: 5%;"></el-image>
                            </el-carousel-item>
                        </el-carousel>
                        <div class="title_block">
                            <div class="pest_image_title">治理过程</div>
                        </div>
                    </div>
                    <div style="width: 28%;height:100%;text-align: center;">
                        <el-carousel :interval="3000" arrow="always" style="height: 90%;">
                            <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                    style="width: 100%;height: 100%;margin-top: 5%;"></el-image>
                            </el-carousel-item>
                        </el-carousel>
                        <div class="title_block">
                            <div class="pest_image_title">治理后</div>
                        </div>
                    </div>


                </div>

                <!-- <div style=" position: absolute; top: 0; left: 0; height: 100%;width: 100%;
    display: flex;
    justify-content: space-between;margin-top: 2%;">
                    <div style="height: 86%;width: 30%;margin-left:  2%;">
                        <div style="height: 100%;width: 100%;">
                            <el-carousel :interval="5000" arrow="always" style="height: 90%;">
                                <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                    <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                        style="width: 100%;height: 100%;"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                            <div style="height: 1vw;text-align: center;font-size: 0.3vw;font-size: 1vw;
    font-weight: 600;padding: 1% 0;margin-bottom: 5%;">退化照片</div>
                        </div>
                    </div>
                    <div style="height: 86%;width: 30%;">
                        <div style="height: 100%;width: 100%;">
                            <el-carousel :interval="5000" arrow="always" style="height: 90%;">
                                <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                    <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                        style="width: 100%;height: 100%;"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                            <div style="height: 1vw;text-align: center;font-size: 0.3vw;font-size: 1vw;
    font-weight: 600;padding: 1% 0;margin-bottom: 5%;">治理过程</div>
                        </div>
                    </div>
                    <div style="height: 86%;width: 30%; margin-right: 2%;">
                        <div style="height: 100%;width: 100%;">
                            <el-carousel :interval="5000" arrow="always" style="height: 90%;">
                                <el-carousel-item v-for="item in 4" :key="item" style="height: 100%;">
                                    <el-image :src="require('@/assets/large-screen-img/gl.png')" fit="fit"
                                        style="width: 100%;height: 100%;"></el-image>
                                </el-carousel-item>
                            </el-carousel>
                            <div style="height: 1vw;text-align: center;font-size: 0.3vw;font-size: 1vw;
    font-weight: 600;padding: 1% 0;margin-bottom: 5%;">治理后</div>
                        </div>
                    </div>

                </div> -->

            </dv-border-box-1>
        </div>

    </div>
</template>
<script>

import leftTop from "../comp/shouye/leftTop.vue";
import leftBottom from "../comp/shouye/leftBottom.vue";
import rightBottom from "../comp/shouye/rightBottom.vue";
import rightTop from "../comp/shouye/rightTop.vue";


export default {
    components: { leftTop, leftBottom, rightBottom, rightTop },
    props: {
        show: {
            type: Boolean,
            default: true
        },
        maptype: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            config: {
                header: ['列1', '列2'],
                data: [
                    ['行1列1', '行1列2'],
                    ['行2列1', '行2列2'],
                    ['行3列1', '行3列2'],
                    ['行4列1', '行4列2'],
                    ['行5列1', '行5列2'],
                    ['行6列1', '行6列2'],
                    ['行7列1', '行7列2']
                ],
                headerBGC: "#008080",
                oddRowBGC: "rgba(0, 128, 128,0.5)",
                evenRowBGC: "rgba(0, 128, 128,0.5)",
                align:['center','center']
            },


            projectquery: {
                id: "",
                projectNum: "",
                projectName: "",
                projectContent: "",
                contentInfo: "",
                city: "",
                conty: "",
                styear: "",
                etyear: "",
                startyear: "",
                endyear: ""
            },
            ecoprojectdata: [],
            bar: {
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c}万亩 ({d}%)",
                    position: [10, 10]
                },

                series: [
                    {
                        name: "草地型",
                        type: "pie",
                        minAngle: 5,
                        avoidLabelOverlap: true,
                        radius: ["0", "65%"],
                        // avoidLabelOverlap:
                        label: {
                            fontSize: 10,
                            normal: {
                                formatter: "{c|{c}公顷}\n {d|{d}%}",
                                rich: {
                                    c: {
                                        color: "#fff"
                                    },
                                    d: {
                                        color: "#00ffe4"
                                    }
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true
                            },
                            length: 0.001
                        },
                        data: [
                            {
                                name: "芨芨草型",
                                value: 264.78,
                                itemStyle: { normal: { color: "#b14ffc" } }
                            },

                            {
                                name: "西北针茅、早熟禾型",
                                value: 67795.63,
                                itemStyle: { normal: { color: "#00ffe4" } }
                            },
                            {
                                name: "苔草、杂类草型",
                                value: 21298.37,
                                itemStyle: { normal: { color: "#ff6969" } }
                            },
                            {
                                name: "羊草、杂类草型",
                                value: 10366.94,
                                itemStyle: { normal: { color: "#f6b37f" } }
                            },

                        ]
                    }
                ]
            },
            resourcebar: {
                legend: {
                    show: false
                },
                grid: {
                    left: "30px",
                    right: "25px",
                    bottom: "0",
                    top: "30px",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}:{c0}公顷"
                },
                xAxis: {
                    type: "category",
                    data: [
                        "高寒草甸类",
                        "高寒草原类",
                        "高寒荒漠类",
                        "温性典型草原类",
                        "温性荒漠类",
                        "低地草甸类",
                        "山地草甸类"
                    ],
                    axisLabel: {
                        show: false,
                        rotate: 15,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                dataZoom: {
                    show: true,
                    realtime: true,
                    start: 0,
                    type: "inside",
                    end: 100,
                    backgroundColor: "rgba(19,227,227,0.3)"
                },

                yAxis: {
                    name: "公顷",
                    type: "value",
                    splitLine: { show: false },
                    axisLabel: {
                        show: "true",

                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },

                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                series: {
                    data: [0, 0, 0, 78162.58, 0, 21563.16, 0], //this.dataSource.ydata[0].data,
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                        color: "#fff"
                    },
                    itemStyle: {
                        //  color: "#0099FF"
                        normal: {
                            // 随机显示
                            //color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}

                            // 定制显示（按顺序）
                            color: function (params) {
                                var colorList = {
                                    高寒草甸类: "rgb(0,133,168)",
                                    高寒草原类: "rgb(158,188,216)",
                                    高寒荒漠类: "rgb(190,255,231)",
                                    温性典型草原类: "rgb(77,230,0)",
                                    温性荒漠类: "rgb(233,255,190)",
                                    低地草甸类: "rgb(103,119,206)",
                                    山地草甸类: "rgb(122,182,245)"
                                };

                                return colorList[params.name];
                            }
                        }
                    }
                }
            },
            //生态修复规模
            areapie: {
                title: {
                    // text:'统计表',
                    left: "center"
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c}公顷 ({d}%)"
                },
                series: [
                    {
                        name: "工程规模",
                        type: "pie",
                        minAngle: 5,
                        avoidLabelOverlap: true,
                        radius: ["0%", "80%"],
                        // avoidLabelOverlap:
                        label: {
                            fontSize: 10,
                            color: "#fbfffd",
                            formatter: "{c}公顷",
                            position: "inner"
                        },
                        labelLine: {
                            normal: {
                                show: false
                            },
                            length: 0.001
                        },
                        data: [
                            {
                                value: 0,
                                name: "退牧还草工程",
                                itemStyle: { normal: { color: "#9b04f9" } }
                            },
                            {
                                value: 0,
                                name: "祁连山工程1",
                                itemStyle: { normal: { color: "#0a8cff" } }
                            },
                            {
                                value: 0,
                                name: "祁连山工程2",
                                itemStyle: { normal: { color: "#0a8cff" } }
                            },
                            {
                                value: 0,
                                name: "三江源二期",
                                itemStyle: { normal: { color: "#45f0ea" } }
                            },
                            {
                                value: 0,
                                name: "生态修复工程",
                                itemStyle: { normal: { color: "#3e04f9" } }
                            }
                        ]
                    }
                ]
            },
            //生态修复资金
            moneypie: {
                legend: {
                    show: false
                },
                grid: {
                    left: "20px",
                    right: "25px",
                    bottom: "25px",
                    top: "30px",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}:{c0}万亩"
                },
                xAxis: {
                    type: "category",
                    data: [
                        "退牧还草工程",
                        "生态修复工程1",
                        "生态修复工程2",
                        "祁连山工程1",
                        "祁连山工程2",
                        "三江源二期"
                    ],
                    axisLabel: {
                        show: false,
                        rotate: 15,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                dataZoom: {
                    show: true,
                    realtime: true,
                    start: 0,
                    type: "inside",
                    end: 100,
                    backgroundColor: "rgba(19,227,227,0.3)"
                },

                yAxis: {
                    name: "万元",
                    type: "value",
                    splitLine: { show: false },
                    axisLabel: {
                        show: "true",

                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },

                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                series: {
                    data: [0, 0, 0, 0, 0, 0], //this.dataSource.ydata[0].data,
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                        color: "#fff"
                    },
                    itemStyle: {
                        //  color: "#0099FF"
                        normal: {
                            // 随机显示
                            //color:function(d){return "#"+Math.floor(Math.random()*(256*256*256-1)).toString(16);}

                            // 定制显示（按顺序）
                            color: function (params) {
                                var colorList = {
                                    退牧还草工程: "#9b04f9",
                                    生态修复工程: "#3e04f9",
                                    生态修复工程1: "#462fb9",
                                    生态修复工程2: "#562fb9",
                                    祁连山工程1: "#0a8cff",
                                    祁连山工程2: "#0a8cff",
                                    三江源二期: "#45f0ea"
                                };

                                return colorList[params.name];
                            }
                        }
                    }
                }
            },
            //综合覆盖度
            overagebar: {
                legend: {
                    show: false
                },
                grid: {
                    left: "30px",
                    right: "25px",
                    bottom: "0",
                    top: "30px",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}:{c0}%"
                },
                xAxis: {
                    type: "category",
                    data: [
                        "康保镇",
                        "张纪镇",
                        "土城子镇",
                        "邓油坊镇",
                        "李家地镇",
                        "照阳河镇",
                        "屯垦镇",
                        "闫油坊乡",
                        "丹清河乡",
                        "哈咇嘎乡",
                        "二号卜乡",
                        "芦家营乡",
                        "忠义乡",
                        "处长地乡",
                        "满德堂乡",
                        "康保牧场",
                        "屯垦林场",
                    ],
                    axisLabel: {
                        show: "true",
                        rotate: 0,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                dataZoom: {
                    show: true,
                    realtime: true,
                    start: 0,
                    type: "inside",
                    end: 100
                },

                yAxis: {
                    name: "%",
                    type: "value",
                    splitLine: { show: false },
                    axisLabel: {
                        show: "true",

                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                series: {
                    // data: [58.89,30.63,83.70,83.01,38.09,74.81,88.54,90.45,88.26,76.08,89.20,75.40,67.81,81.87,70.71,59.94,84.65,], //this.dataSource.ydata[0].data,
                    data: [
                        72.64, 89.71, 87.41, 74.91, 87.42, 24.99, 55.11, 74.41, 75.07, 83.39, 59.20, 81.50, 90.32, 83.51, 58.97, 33.16, 74.27
                    ],
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                        color: "#fff",
                    },
                    markLine: {
                        label: {
                            position: "end",
                            width: 30,
                            padding: [-13, 0, 0, -9],
                            fontWeight: 400
                        },

                        data: [{ name: 'Avg', yAxis: 65.27 }]
                    },
                    barMaxWidth: 20,
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = {
                                    满德堂乡: "#82fdf3",
                                    照阳河镇: "#699bf7",
                                    处长地乡: "#3874fc",
                                    哈咇嘎乡: "#3450fb",
                                    康保牧场: "#3745f3",
                                    邓油坊镇: "#755efb",
                                    忠义乡: "#ba5efb",
                                    张纪镇: "#fc7df8",
                                    土城子镇: "#12fdf3",
                                    丹清河乡: "#6b9bf7",
                                    李家地镇: "#3h74fc",
                                    闫油坊乡: "#3f50fb",
                                    二号卜乡: "#3145f3",
                                    芦家营乡: "#7g5efb",
                                    康保镇: "#bb5efb",
                                    屯垦镇: "#bc7df8",
                                    屯垦林场: "#cc7df8"
                                };

                                return colorList[params.name];
                            }
                        }
                    }
                }
            },
            //退化面积
            degrassareapie: {
                title: {
                    // text:'统计表',
                    left: "center"
                },
                legend: {
                    bottom: 0,
                    // type: "scroll",
                    textStyle: {
                        color: "#fbfffd"
                    },
                    pageIconColor: "#00FFFF",
                    pageTextStyle: {
                        color: "#00FFFF"
                    }
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c}公顷<br/>占比： {d}%"
                },
                // visualMap: {
                //   show: false,
                //   min: 80,
                //   max: 600,
                //   inRange: {
                //     colorLightness: [0, 1]
                //   }
                // },
                series: [
                    {
                        name: "草原退化",
                        type: "pie",
                        radius: [0, 48],
                        center: ["50%", "50%"],

                        itemStyle: {
                            color: "#c23531",
                            shadowBlur: 200,
                            shadowColor: "rgba(0, 0, 0, 0.5)"
                        },
                        animationType: "scale",
                        animationEasing: "elasticOut",
                        // avoidLabelOverlap:
                        label: {
                            fontSize: 10,
                            normal: {
                                formatter: "{c|{c}公顷}\n {d|{d}%}",
                                rich: {
                                    c: {
                                        color: "#fff"
                                    },
                                    d: {
                                        color: "#00ffe4"
                                    }
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true
                            }
                        },
                        data: [
                            {
                                value: 46004.65,
                                name: "轻度退化",
                                itemStyle: { normal: { color: "#34da3c" } }
                            },
                            {
                                value: 8410.24,
                                name: "中度退化",
                                itemStyle: { normal: { color: "#efe43b" } }
                            },

                            {
                                value: 45310.85,
                                name: "无退化",
                                itemStyle: { normal: { color: "#019308" } }
                            },
                            {
                                value: 0,
                                name: "重度退化",
                                itemStyle: { normal: { color: "#be2121" } }
                            }
                        ]
                    }
                ]
            },
            levelbar: {
                legend: {
                    show: false
                },
                grid: {
                    left: "30px",
                    right: "25px",
                    bottom: "0",
                    top: "30px",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}:{c0}公顷<br/>"
                },
                xAxis: {
                    type: "category",
                    data: ["1级", "2级", "3级", "4级", "5级", "6级", "7级", "8级"],
                    axisLabel: {
                        show: "true",
                        rotate: 0,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                dataZoom: {
                    show: true,
                    realtime: true,
                    start: 0,
                    type: "inside",
                    end: 100
                },

                yAxis: {
                    name: "公顷",
                    type: "value",
                    splitLine: { show: false },
                    axisLabel: {
                        show: "true",

                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                series: {
                    data: [131.75, 579.16, 5572.62, 22763.59, 45902.92, 22906.81, 1651.00, 217.87], //this.dataSource.ydata[0].data,
                    type: "bar",
                    barMaxWidth: 20,
                    label: {
                        show: true,
                        position: "top",
                        color: "#fff"
                    },
                    itemStyle: {
                        normal: {
                            color: function (params) {
                                var colorList = [
                                    "#008009",
                                    "#00ab0c",
                                    "#42d900",
                                    "#75ff6b",
                                    "#8eff42",
                                    "#c3fb57",
                                    "#fbf957",
                                    "#dbb622"
                                ];
                                return colorList[params.dataIndex];
                            }
                        }
                    }
                }
            },
            //质量与等级
            levelpie: {
                title: {
                    // text:'统计表',
                    left: "center"
                },
                legend: {
                    bottom: 0,
                    type: "scroll",
                    textStyle: {
                        color: "#fbfffd"
                    },
                    pageIconColor: "#00FFFF",
                    pageTextStyle: {
                        color: "#00FFFF"
                    },
                    data: [
                        "优质高产",
                        "优质中产",
                        "优质低产",
                        "中质高产",
                        "中质中产",
                        "中质低产",
                        "劣质高产",
                        "劣质中产",
                        "劣质低产"
                    ]
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c}万亩<br/>占比:{d}%"
                },
                series: [
                    {
                        name: "草原级",
                        type: "pie",
                        radius: ["0", "40%"],
                        // avoidLabelOverlap:
                        label: {
                            position: "inner",

                            color: "#fbfffd"
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {
                                value: 6611.88,
                                name: "一级",
                                itemStyle: { normal: { color: "#33ffcc" } }
                            },
                            {
                                value: 3571.98,
                                name: "二级",
                                itemStyle: { normal: { color: "#66ffcc" } }
                            },
                            {
                                value: 21635.86,
                                name: "三级",
                                itemStyle: { normal: { color: "#6699ff" } }
                            },
                            {
                                value: 13232.8,
                                name: "四级",
                                itemStyle: { normal: { color: "#0066cc" } }
                            },
                            {
                                value: 8450.64,
                                name: "五级",
                                itemStyle: { normal: { color: "#00BFFF" } }
                            },
                            {
                                value: 7272.99,
                                name: "六级",
                                itemStyle: { normal: { color: "#8470FF" } }
                            },
                            {
                                value: 4801.86,
                                name: "七级",
                                itemStyle: { normal: { color: "#FFDEAD" } }
                            },
                            {
                                value: 232.0,
                                name: "八级",
                                itemStyle: { normal: { color: "#EEDC82" } }
                            }
                        ]
                    },
                    {
                        name: "草原质量",
                        type: "pie",
                        radius: ["50%", "80%"],
                        // avoidLabelOverlap:
                        label: {
                            show: false,
                            color: "#fbfffd"
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {
                                value: 4218.56,
                                name: "优质高产",
                                itemStyle: { normal: { color: "#38a800" } }
                            },
                            {
                                value: 103.93,
                                name: "优质中产",
                                itemStyle: { normal: { color: "#a8a800" } }
                            },
                            {
                                value: 982.82,
                                name: "优质低产",
                                itemStyle: { normal: { color: "#a87000" } }
                            },
                            {
                                value: 13232.8,
                                name: "中质高产",
                                itemStyle: { normal: { color: "#4ce600" } }
                            },
                            {
                                value: 21142.21,
                                name: "中质中产",
                                itemStyle: { normal: { color: "#e6e600" } }
                            },
                            {
                                value: 235.96,
                                name: "中质低产",
                                itemStyle: { normal: { color: "#e69800" } }
                            },

                            {
                                value: 1566.2,
                                name: "劣质中产",
                                itemStyle: { normal: { color: "#ffff73" } }
                            },
                            {
                                value: 136.08,
                                name: "劣质低产",
                                itemStyle: { normal: { color: "#ffd37f" } }
                            }
                        ]
                    }
                ]
            },
            //管护员考核
            checkpie: {
                title: {
                    // text:'统计表',
                    left: "center"
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{a} <br/>{b}: {c}人({d}%)"
                },
                series: [
                    {
                        name: "考核结果",
                        type: "pie",
                        radius: ["0%", "40%"],
                        // avoidLabelOverlap:
                        // label: {
                        //   fontSize: 10,
                        //   color: "#fbfffd"
                        // },
                        label: {
                            fontSize: 10,
                            position: "inside",
                            normal: {
                                formatter: "{c|{b}}\n {d|{d}%}",
                                rich: {
                                    c: {
                                        color: "#fff"
                                    },
                                    d: {
                                        color: "#00ffe4"
                                    }
                                }
                            }
                        },
                        labelLine: {
                            normal: {
                                show: true
                            }
                        },
                        data: [
                            {
                                value: 0,
                                name: "合格",
                                itemStyle: { normal: { color: "#f49101" } }
                            },
                            {
                                value: 0,
                                name: "优秀",
                                itemStyle: { normal: { color: "#e4f646" } }
                            },
                            {
                                value: 0,
                                name: "良好",
                                itemStyle: { normal: { color: "#f4e237" } }
                            },
                            {
                                value: 0,
                                name: "不合格",
                                itemStyle: { normal: { color: "#e2621c" } }
                            }
                        ]
                    }
                ]
            },
            //管护员资金
            supervisormoneypie: {
                legend: {
                    show: false
                },
                grid: {
                    left: "30px",
                    right: "25px",
                    bottom: "0",
                    top: "30px",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis",
                    formatter: "{b}:{c0}%"
                },
                xAxis: {
                    type: "category",
                    data: ["2016", "2017", "2018", "2019", "2020"],
                    axisLabel: {
                        show: "true",
                        rotate: 0,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                dataZoom: {
                    show: true,
                    realtime: true,
                    start: 0,
                    type: "inside",
                    end: 100
                },

                yAxis: {
                    name: "万元",
                    type: "value",
                    splitLine: { show: false },
                    axisLabel: {
                        show: "true",

                        textStyle: {
                            color: "#fff",
                            fontSize: 10
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#00CCFF",
                            width: 2
                        }
                    }
                },
                series: {
                    data: [0, 0, 0, 0, 0], //this.dataSource.ydata[0].data,
                    type: "bar",
                    label: {
                        show: true,
                        position: "top",
                        color: "#fff"
                    },
                    barMaxWidth: 20,
                    itemStyle: {
                        normal: {
                            color: "#1fddff"
                        }
                    }
                }
            }
        };
    },
    mounted() {

    },
    methods: {
        loadShp() {
            console.log("123")
            setTimeout(() => {
                this.bus.$emit("layers", {
                    // baseLayer: "2",
                    // operLayer: [
                    //   "ef487a7c672847abb2f3a41991ba3e32",
                    //   "ccf3a52e20704310992ba9e1bc855e22"
                    // ],
                    // operLayer: [
                    //   "ef487a7c672847abb2f3a41991ba3e32",
                    //   "bc58352ce4cf428cb3b8fa4a24e627f2"
                    // ],康保
                    operLayer: "49d22e44e12c4c1c94ede4702de251a6",//红原县
                    extent: {
                        center: [102.54525, 32.4],
                        //  resolution: 0.016
                        resolution: 0.002
                    }
                });

            }, 1000);


        },
        getyear(value) {
            return new Date(value).getFullYear();
        },
        yearchange(val) {
            let data = this.ecoprojectdata[val];
            this.areapie.series[0].data = data.areadata;
            this.moneypie.xAxis.data = data.moneydata.xdata;
            this.moneypie.series.data = data.moneydata.ydata;
        },
        getprojectlist() {
            bapi.getprojectlist(this.projectquery).then(res => {
                var colorList = {
                    退牧还草工程: "#9b04f9",

                    生态修复工程: "#3e04f9",
                    生态修复工程1: "#462fb9",
                    生态修复工程2: "#562fb9",
                    祁连山工程1: "#0a8cff",
                    祁连山工程2: "#0a8cff",
                    三江源二期: "#45f0ea"
                };
                let colors = [
                    "#0099ff",
                    "#00CED1",
                    "#5F9EA0",
                    "#2E8B57",
                    "#20B2AA",
                    "#00FF7F",
                    "#00BFFF",
                    "#0000FF",
                    "#4682B4",
                    "#00CED1",
                    "#3CB371"
                ];
                let colorobj = {};
                res.data.map(d => {
                    let year = this.ecoprojectdata.find(t => t.year == d.year);
                    let cr = colorList[d.constructionName];
                    if (!cr) {
                        cr = colors[Object.keys(colorobj).length];
                        colorobj[d.constructionName] = cr;
                    }
                    if (!year) {


                        year = {
                            year: d.year,
                            areadata: [
                                {
                                    name: d.constructionName,
                                    value: d.projectArea,
                                    itemStyle: {
                                        normal: { color: cr }
                                    }
                                }
                            ],
                            moneydata: {
                                xdata: [d.constructionName],
                                ydata: [d.projectMoney]
                            }
                            // [
                            //   {
                            //     name: d.constructionName,
                            //     value: d.projectMoney,
                            //     itemStyle: {
                            //       normal: { color: cr }
                            //     }
                            //   }
                            // ]
                        };
                        this.ecoprojectdata.push(year);
                    } else {
                        let areadata = year.areadata.find(
                            t => t.name == d.constructionName
                        );

                        if (!areadata) {
                            areadata = {
                                name: d.constructionName,
                                value: d.projectArea,
                                itemStyle: {
                                    normal: { color: cr }
                                }
                            };

                            year.areadata.push(areadata);
                        } else {
                            areadata.value += parseInt(d.projectArea.toFixed(2));
                        }
                        let update = false;
                        for (let i = 0; i < year.moneydata.xdata.length; i++) {
                            if (year.moneydata.xdata[i] == d.constructionName) {
                                year.moneydata.ydata[i] += parseInt(d.projectMoney.toFixed(2));
                                update = true;
                                break;
                            }
                        }
                        if (!update) {
                            year.moneydata.xdata.push(d.constructionName);
                            year.moneydata.ydata.push(d.projectMoney);
                        }
                        //    let mdata = year.moneydata.find(t => t.name == d.constructionName);
                        // if (!mdata) {
                        //   mdata = {
                        //     name: d.constructionName,
                        //     value: d.projectMoney,
                        //     itemStyle: {
                        //       normal: { color: cr }
                        //     }
                        //   };
                        //   year.moneydata.push(mdata);
                        // } else {
                        //   mdata.value += d.projectMoney;
                        // }
                    }
                });
            });
        }
    }
};
</script>
  
  
<style lang="scss"  scoped>
.zhzb_title {
    height: 20%;
    font-size: 1vw;
    font-weight: 800;
    color: #fff;
    display: flex;
    align-items: center;
}

.title_block {
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pest_image_title {
    // display: inline-block;
    // height: 100%;
    // line-height: 10%;

    color: #fff;
    font-size: 0.9vw;
    font-weight: 800;
    // padding: 3% 0;

}

.content1 {
    //   display: flex;
    // justify-content: space-between;
    // background-color: red;
    display: grid !important;
    grid-template-columns: 4fr 7fr 4fr !important;
    // padding-top: 90px;
    // height: calc(60% - 60px);
    height: 60%;

    .block {
        height: 100%;
        // background-color: #00ffff;

    }
}

.content2 {
    height: calc(40% - 60px);
}

/deep/ .el-carousel__arrow {
    font-weight: 800;
    font-size: 2vw;
    line-height: 2vw;
}

/deep/ .el-carousel__container {
    height: 100%;
}

.image_title {
    font-style: oblique;
    text-align: center;
    color: #00ffff;
    font-size: 1.5vw;
    height: 1.5vw;
    line-height: 1.5vw;
    font-weight: 500;
    margin: 4px 0;
}

.title_icon {
    transform: rotate(90deg);
    font-weight: 700;
    color: #00ffff;
}

.resource-title {
    color: #fff;
    font-size: 1.5vw;
    height: 1.5vw;
    line-height: 1.5vw;
    margin: 4px 0;
    font-weight: 500;
}

.image_base {
    width: 100%;
    height: 100%;
    padding: 16px 16px 0 16px;
    background-image: url("../../../assets/large-screen-img/ditu.png");
    background-size: cover;
    background-position: center center;
}
</style>
  
  